<template>
  <div class="page home">
    <HomeHero />
    <HomeNews1 />
    <HomeHyjy />
    <!-- <HomeZzgz /> -->
    <!--  <HomeZgyw />
    <HomeAi /> -->
    <!-- <HomeNews /> -->
    <!-- <HomeEg /> -->
    <!-- <HomeDec /> -->
  </div>
</template>

<script>
import HomeHero from "@/components/HomeHero.vue";
import HomeZzgz from "./components/zzgz.vue";
import HomeZgyw from "./components/zgyw.vue";
import HomeAi from "./components/ai.vue";
// import HomeNews from "./components/news.vue";
// import HomeCustomer from "./components/customer‌.vue";
import HomeDec from "./components/dec.vue";
import HomeNews1 from "./components/news1.vue";
import HomeHyjy from "./components/hyjy.vue";
import HomeEg from "./components/eg.vue";

export default {
  name: "Home",
  components: {
    HomeHero,
    HomeZzgz,
    HomeZgyw,
    HomeAi,
    // HomeNews,
    // HomeCustomer,
    HomeEg,
    HomeDec,
    HomeNews1,
    HomeHyjy,
  },
};
</script>
